var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoBreakdown = function SvgLogoBreakdown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    className: "o-s",
    fill: "currentcolor",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.6 27.8",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8,27.8c-2.4,0-4.3-0.7-5.9-2.1c-1.5-1.4-2.5-3.4-2.8-5.9L0,19.3l5-1.1L5,18.7c0.2,1.8,0.6,2.5,0.8,2.9       c0.7,1,1.7,1.5,3.1,1.5c1.1,0,1.9-0.3,2.7-1.1c0.7-0.7,1.1-1.6,1.1-2.7c0-0.4-0.1-0.9-0.2-1.2c-0.1-0.4-0.3-0.7-0.6-1       c-0.3-0.3-0.6-0.6-1-0.9c-0.5-0.3-1-0.6-1.6-0.8l-2.5-1c-3.7-1.6-5.6-3.9-5.6-7c0-2.1,0.8-3.8,2.4-5.2C5.2,0.7,7.1,0,9.5,0       c3.1,0,5.6,1.6,7.4,4.6L17.1,5l-4,2.4L12.8,7c-0.7-1.2-1.2-1.6-1.5-1.8c-0.5-0.3-1.1-0.5-1.9-0.5c-1,0-1.7,0.3-2.4,0.8       C6.5,6,6.2,6.6,6.2,7.4c0,1,0.8,1.9,2.5,2.6l2.6,1.1c2.2,0.9,3.8,2,4.8,3.3c1,1.3,1.6,2.9,1.6,4.8c0,2.5-0.8,4.6-2.5,6.2       C13.4,26.9,11.3,27.8,8.8,27.8z M1.2,20.1c0.4,2,1.2,3.7,2.5,4.8c1.4,1.2,3.1,1.8,5.2,1.8c2.2,0,4.1-0.7,5.6-2.2       c1.5-1.4,2.2-3.3,2.2-5.5c0-1.6-0.5-3-1.3-4.2c-0.9-1.2-2.4-2.1-4.4-2.9l-2.6-1.1c-2.1-0.9-3.1-2-3.1-3.5c0-1.1,0.4-1.9,1.3-2.7       c0.8-0.7,1.8-1,3-1c1,0,1.8,0.2,2.4,0.6c0.5,0.3,1,0.9,1.6,1.7l2.3-1.3C14.2,2.2,12.1,1,9.5,1C7.4,1,5.7,1.6,4.3,2.9       c-1.4,1.2-2,2.7-2,4.5c0,2.7,1.6,4.7,5,6.1l2.5,1c0.7,0.3,1.2,0.6,1.7,0.9c0.5,0.3,0.9,0.7,1.3,1.1c0.3,0.4,0.6,0.8,0.7,1.3       c0.2,0.5,0.2,1,0.2,1.5c0,1.4-0.5,2.5-1.3,3.4c-0.9,0.9-2,1.4-3.4,1.4c-1.7,0-3-0.6-3.9-1.9c-0.4-0.6-0.7-1.5-0.9-2.8L1.2,20.1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    className: "f-c-fake",
    fill: "currentcolor",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.3 26.7",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3,1.9v4.6c-2.2-1.9-4.6-2.8-7-2.8c-2.6,0-4.9,1-6.7,2.9c-1.8,1.9-2.7,4.2-2.7,6.9c0,2.7,0.9,5,2.7,6.8       c1.8,1.9,4.1,2.8,6.7,2.8c1.4,0,2.5-0.2,3.5-0.7c0.5-0.2,1.1-0.5,1.7-0.9c0.6-0.4,1.2-0.8,1.8-1.4v4.7c-2.2,1.3-4.6,1.9-7,1.9       c-3.7,0-6.8-1.3-9.4-3.9C1.3,20.3,0,17.2,0,13.5c0-3.3,1.1-6.2,3.3-8.8C5.9,1.6,9.4,0,13.6,0C15.9,0,18.2,0.6,20.3,1.9z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    className: "o-o",
    fill: "currentcolor",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27.9 27.7",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8,27.7c-3.4,0-6.6-1.2-9.3-3.6C1.5,21.5,0,18,0,13.7C0,10,1.4,6.7,4.1,4c2.7-2.7,6.1-4,9.9-4c3.8,0,7.1,1.4,9.8,4.1       c2.7,2.7,4.1,6,4.1,9.8c0,3.8-1.4,7.1-4.1,9.8C21.1,26.4,17.7,27.7,13.8,27.7z M14,1c-3.6,0-6.7,1.3-9.2,3.8C2.3,7.3,1,10.3,1,13.7       c0,3.9,1.4,7.2,4.2,9.6c2.5,2.2,5.4,3.3,8.6,3.3c3.6,0,6.7-1.3,9.3-3.7c2.6-2.5,3.8-5.5,3.8-9.1c0-3.5-1.3-6.6-3.8-9.1       C20.6,2.3,17.5,1,14,1z M13.9,24.1c-2.6,0-5-1-6.9-2.9c-2-1.9-3-4.4-3-7.4c0-2.8,1-5.3,2.9-7.2c1.9-2,4.3-3,7.2-3c2.8,0,5.2,1,7.1,3       C23.1,8.6,24,11,24,13.9c0,2.8-1,5.3-2.9,7.3C19.2,23.1,16.7,24.1,13.9,24.1z M14,4.7c-2.6,0-4.7,0.9-6.4,2.7C5.8,9.1,5,11.2,5,13.8       c0,2.7,0.9,4.9,2.7,6.7c1.8,1.8,3.9,2.6,6.2,2.6c2.6,0,4.7-0.9,6.5-2.7c1.7-1.8,2.6-4,2.6-6.5c0-2.6-0.9-4.8-2.6-6.5       C18.7,5.5,16.6,4.7,14,4.7z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    className: "o-c",
    fill: "currentcolor",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.3 27.8",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8,27.8c-3.8,0-7.1-1.3-9.8-4c-2.7-2.7-4-6-4-9.7c0-3.4,1.1-6.5,3.4-9.1C6.1,1.6,9.8,0,14.1,0c0,0,0,0,0.1,0       c2.4,0,4.7,0.7,6.9,2l0.3,0.1v6l-0.8-0.7c-2.1-1.8-4.4-2.7-6.6-2.7c-2.5,0-4.6,0.9-6.3,2.7c-1.7,1.8-2.6,4-2.6,6.6       c0,2.6,0.8,4.7,2.6,6.5c1.7,1.7,3.8,2.6,6.3,2.6c1.3,0,2.4-0.2,3.3-0.6c0.5-0.2,1.1-0.5,1.6-0.9c0.6-0.4,1.2-0.8,1.8-1.3l0.8-0.7       v6.1l-0.3,0.1C18.8,27.1,16.3,27.8,13.8,27.8z M14.2,1C14.2,1,14.1,1,14.2,1c-4.1,0-7.5,1.5-10,4.5C2.1,8,1,10.9,1,14       c0,3.6,1.2,6.5,3.7,9c2.5,2.5,5.5,3.7,9.1,3.7c2.2,0,4.4-0.6,6.5-1.7v-3.3c-0.3,0.3-0.7,0.5-1,0.7c-0.6,0.4-1.2,0.7-1.8,0.9       c-1,0.5-2.2,0.7-3.7,0.7c-2.8,0-5.2-1-7.1-2.9c-1.9-2-2.9-4.4-2.9-7.2c0-2.9,1-5.3,2.9-7.3c1.9-2,4.3-3,7.1-3c2.2,0,4.4,0.8,6.5,2.3       V2.7C18.3,1.6,16.3,1,14.2,1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    className: "o-i",
    fill: "currentcolor",
    x: "0px",
    y: "0px",
    viewBox: "0 0 4.9 26.8",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9,26.8H0V0h4.9V26.8z M1,25.8h2.9V1H1V25.8z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    className: "o-a",
    fill: "currentcolor",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26.6 29.1",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6,29.1h-5.4l-2.7-6.3H8.2l-2.9,6.3H0L13.6,0L26.6,29.1z M21.9,28.1h3.1L13.5,2.5L1.6,28.1h3.1l2.9-6.3h11.7L21.9,28.1z       M18.1,19.2H8.7l4.8-10.5L18.1,19.2z M10.3,18.2h6.2l-3-7L10.3,18.2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    className: "o-l",
    fill: "currentcolor",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12.5 26.8",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5,26.8H0V0h4.9v22.1h7.6V26.8z M1,25.8h10.4v-2.6H3.9V1H1V25.8z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    className: "f-c",
    fill: "currentcolor",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.3 26.7",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3,1.9v4.6c-2.2-1.9-4.6-2.8-7-2.8c-2.6,0-4.9,1-6.7,2.9c-1.8,1.9-2.7,4.2-2.7,6.9c0,2.7,0.9,5,2.7,6.8       c1.8,1.9,4.1,2.8,6.7,2.8c1.4,0,2.5-0.2,3.5-0.7c0.5-0.2,1.1-0.5,1.7-0.9c0.6-0.4,1.2-0.8,1.8-1.4v4.7c-2.2,1.3-4.6,1.9-7,1.9       c-3.7,0-6.8-1.3-9.4-3.9C1.3,20.3,0,17.2,0,13.5c0-3.3,1.1-6.2,3.3-8.8C5.9,1.6,9.4,0,13.6,0C15.9,0,18.2,0.6,20.3,1.9z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    className: "f-u",
    fill: "currentcolor",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.1 26.2",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9,0v15.5c0,2.2,0.4,3.8,1.1,4.8c1.1,1.5,2.6,2.2,4.5,2.2c2,0,3.5-0.7,4.6-2.2c0.7-1,1.1-2.6,1.1-4.8V0h3.9v16.6       c0,2.7-0.8,4.9-2.5,6.7c-1.9,2-4.2,2.9-7,2.9c-2.8,0-5.1-1-7-2.9c-1.7-1.8-2.5-4-2.5-6.7V0H3.9z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    className: "f-r",
    fill: "currentcolor",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.7 25.8",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7,14.8l8,11h-4.8L4.6,15.2H3.9v10.5H0V0h4.6c3.4,0,5.9,0.6,7.4,1.9c1.7,1.4,2.5,3.3,2.5,5.6c0,1.8-0.5,3.4-1.6,4.7       C11.8,13.6,10.4,14.4,8.7,14.8z M3.9,11.8h1.2c3.7,0,5.5-1.4,5.5-4.2c0-2.6-1.8-4-5.4-4H3.9V11.8z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    className: "f-a",
    fill: "currentcolor",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 27.4",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1,21.1h-11l-2.9,6.3H0L12.7,0L25,27.4h-4.2L18.1,21.1z M16.5,17.5l-3.8-8.8l-4,8.8H16.5z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    className: "f-t",
    fill: "currentcolor",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15.7 25.8",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8,3.7v22.1H5.9V3.7H0V0h15.7v3.7H9.8z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    className: "f-o",
    fill: "currentcolor",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26.9 26.7",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0,13.2c0-3.6,1.3-6.7,4-9.3C6.6,1.3,9.8,0,13.5,0c3.7,0,6.8,1.3,9.4,3.9c2.6,2.6,4,5.8,4,9.5c0,3.7-1.3,6.8-4,9.4       c-2.7,2.6-5.9,3.9-9.6,3.9c-3.3,0-6.3-1.2-9-3.5C1.5,20.7,0,17.4,0,13.2z M3.9,13.3c0,2.8,1,5.2,2.9,7c1.9,1.8,4.1,2.8,6.6,2.8       c2.7,0,5-0.9,6.8-2.8c1.9-1.9,2.8-4.2,2.8-6.9c0-2.7-0.9-5.1-2.8-6.9c-1.8-1.9-4.1-2.8-6.8-2.8c-2.7,0-4.9,0.9-6.8,2.8       C4.8,8.3,3.9,10.6,3.9,13.3z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    className: "f-r",
    fill: "currentcolor",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.7 25.8",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7,14.8l8,11h-4.8L4.6,15.2H3.9v10.5H0V0h4.6c3.4,0,5.9,0.6,7.4,1.9c1.7,1.4,2.5,3.3,2.5,5.6c0,1.8-0.5,3.4-1.6,4.7       C11.8,13.6,10.4,14.4,8.7,14.8z M3.9,11.8h1.2c3.7,0,5.5-1.4,5.5-4.2c0-2.6-1.8-4-5.4-4H3.9V11.8z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoBreakdown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-breakdown.a9b18574.svg";
export { ForwardRef as ReactComponent };